export enum walkthrough {
  DASHBOARD = 'DASHBOARD',
}
